import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import { useNavigate } from 'react-router-dom';
import FormRender from '../../components/FormRender';
import { dayOptions, monthsOptions, NEWSLETTER_CONFIG_TABLE_KEYS, SCHEDULER_FORM_SETTINGS, weekdaysOptions } from '../../helper';
import Select from "react-select";
import { TableCustom } from '../../components/Table';
import { toast } from 'react-toastify';

const EditScheduler = () => {
  const [isLoading,setIsLoading] = useState(false);
  const [mainIsLoading,setMainIsLoading] = useState(false);
  const axiosInstance = useAxiosInstance();
  const [configObj,setConfigObj] = useState({});
  const history = useNavigate()  
  const [configs,setConfigs] = useState([]);
  const [formData, setFormData] = useState({
          "time":"",
          "start_date":"",
          "mode":"",
          "time_setting_meta":{
              "week_days":[],
              "months":[],
              "days":[]
          },
          "config_pk":null,
          "scheduler_mode":"other",
          "active":true
   });
  const [configMeta,setConfigMeta] = useState({});
  const [isSaving, setIsSaving] = useState(false);
//   const history = useNavigate()

  useEffect(() => {
          setMainIsLoading(true);
          axiosInstance
            .post("/newsletter/v2/get_newsletter_trigger/",{
                scheduler_pk:window.location.pathname.split('/').pop()
            })
            .then((res) => {
              setMainIsLoading(false);
              setConfigObj(res.data.data);   
              setFormData({
                ...res.data.data,
                'scheduler_mode':res?.data?.data?.scheduler_meta_meta?.is_other? 'other': res?.data?.data?.scheduler_meta_meta?.is_task?'task':'newsletter',
                'analysis_period':res?.data?.data?.config_new_settings?.analysis_period
              })
              setConfigMeta(res?.data?.data?.scheduler_meta_meta)
            })
            .catch((err) => {
              setMainIsLoading(false);
            });
      }, []);
   
      useEffect(() => {
              setIsLoading(true);
              axiosInstance
                .post("/newsletter/v2/all_configs/")
                .then((res) => {
                  setIsLoading(false);
                  setConfigs(res.data);
                })
                .catch((err) => {
                  setIsLoading(false);
                });
          }, []);
    
    useEffect(()=>{
        console.log(formData)
    },[formData])      

    if(mainIsLoading){
        return <p>Loading...</p>
    }      
          return (
    <div className="w-full px-6">
       <div className="p-3 my-5 border rounded-lg bg-white w-full">
        <p className="text-2xl text-black font-medium mb-4 flex justify-between"><p>Edit Scheduler(UTC)</p> <button onClick={()=>{
            history('/scheduler/all')
        }} className="bg-black px-2 py-1 text-sm font-medium rounded text-white">See All</button></p>

        <div className="grid grid-cols-3 w-full gap-x-3">
            <FormRender
                formData={formData}
                formSettings={[...SCHEDULER_FORM_SETTINGS[0],{
                    label: "Is Active",
                    type: "select",
                    saveKey: "active",
                    options:[
                    {
                        value:true,
                        label:'True'
                    },
                    {
                        value:false,
                        label:'False'
                    }
                ]
                }]}
                setFormData={setFormData}
            />
        </div>
        {
            formData.mode === 'weekly' && <div>
                <p className="text-sm font-semibold mt-4 mb-2">Week days (Multi-select)</p>
                <Select
                    className="w-full"
                    options={weekdaysOptions
                    }
                    isMulti
                    value={
                        weekdaysOptions.filter(it=> formData?.time_setting_meta?.week_days?.includes(it.value))
                    }
                    onChange={(e) => {
                        let time_setting_meta = {}
                        if(!time_setting_meta.week_days){
                            time_setting_meta['week_days'] = []
                        }
                        time_setting_meta['week_days'] = e.map(it=>it.value)
                        setFormData( prev=> ({...prev, time_setting_meta:time_setting_meta}))        
                    }}
                />
            </div>
        }
        {
            formData.mode === 'monthly' && <div className="grid grid-cols-2 gap-x-3">
                <div>
                <p className="text-sm font-semibold mt-4 mb-2">Months (Multi-select)</p>
                <Select
                    className="w-full"
                    options={monthsOptions}
                    isMulti
                    value={
                        monthsOptions.filter(it=> formData?.time_setting_meta?.months?.includes(it.value))
                    }
                    onChange={(e) => {
                        let time_setting_meta = {...formData?.time_setting_meta}
                        if(!time_setting_meta.months){
                            time_setting_meta['months'] = []
                        }
                        time_setting_meta['months'] = e.map(it=>it.value)
                        setFormData( prev=> ({...prev, time_setting_meta:time_setting_meta}))        
                    }}
                />
                </div>

                <div>        
                <p className="text-sm font-semibold mt-4 mb-2">Days (Multi-select)</p>
                <Select
                    className="w-full"
                    options={dayOptions}
                    isMulti
                    value={
                        dayOptions.filter(it=> formData?.time_setting_meta?.days?.includes(it.value))
                    }
                    onChange={(e) => {
                        let time_setting_meta = {...formData?.time_setting_meta}
                        if(!time_setting_meta.days){
                            time_setting_meta['days'] = []
                        }
                        time_setting_meta['days'] = e.map(it=>it.value)
                        setFormData( prev=> ({...prev, time_setting_meta:time_setting_meta}))        
                    }}
                />
                </div>

            </div>
        }                  
      </div>
      
      <div className="px-3 py-2 bg-white rounded-lg border">
        <FormRender
            formData={formData}
            formSettings={SCHEDULER_FORM_SETTINGS[2]}
            setFormData={setFormData}
        />
      </div>  

      {formData.scheduler_mode === 'other' && <div className="px-3 py-2 mt-4 bg-white rounded-lg border">
        <div className="grid grid-cols-2 gap-x-3">
        <FormRender
            formData={configMeta}
            formSettings={SCHEDULER_FORM_SETTINGS[3]}
            setFormData={setConfigMeta}
        /></div>
       </div>} 

        {formData.scheduler_mode === 'task' && <div className="px-3 py-2 mt-4 bg-white rounded-lg border">
        <div className="grid grid-cols-2 gap-x-3">
        <FormRender
            formData={configMeta}
            formSettings={SCHEDULER_FORM_SETTINGS[4]}
            setFormData={setConfigMeta}
        /></div>
       </div>} 

      {formData.scheduler_mode === 'newsletter' && <div className="px-3 py-2 mt-4 bg-white rounded-lg border">
      <p className="text-sm font-semibold mt-4 mb-2">Select Config ({formData.config_pk})</p>
      <TableCustom
            columns={NEWSLETTER_CONFIG_TABLE_KEYS}
            data={{'data':configs.data}}
            loading={isLoading}
            handleEdit={null}
            handleDelete={null}
            handleSelect={(id)=>{setFormData({...formData, config_pk:id})}}
            className="h-[35vh] max-w-full"
        />
        <FormRender
            formData={formData}
            formSettings={SCHEDULER_FORM_SETTINGS[1]}
            setFormData={setFormData}
        />
       </div>}

       <button 
        className='px-3 py-1 mt-4 border text-white disabled:text-black bg-black rounded-lg text-sm disabled:bg-white  disabled:cursor-not-allowed '
        disabled={isSaving}
        onClick={()=>{
        const payload = {...formData,active: formData.active==="true"?true:false, 'scheduler_pk':window.location.pathname.split('/').pop(),"config_new_settings":{'analysis_period':Number(formData.analysis_period)},"scheduler_meta_meta":{...configMeta,'is_other':formData.scheduler_mode === 'other','is_task':formData.scheduler_mode === 'task'}}
        setIsSaving(true)
        axiosInstance
          .post("/newsletter/v2/update_newsletter_trigger/",payload)
          .then((res) => {
            setIsSaving(false);
            toast.success('Edited successfully!')
            history('/scheduler/all')
          })
          .catch((err) => {
            setIsSaving(false);
          });
       }}>{isSaving? 'loading..':'Save'}</button> 
    </div>
  )
}

export default EditScheduler